/* eslint-disable */
export default {
  noRecords: '未找到任何最近的记录。',
  inBound: '入站',
  outBound: '呼出',
  missed: '未接来电',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
